export class CommonUtils {
    static stdTimezoneOffset(): number {
        var jan = new Date(new Date().getFullYear(), 0, 1);
        var jul = new Date(new Date().getFullYear(), 6, 1);
        return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
    }

    static isDstObserved(): boolean {
        return new Date().getTimezoneOffset() < this.stdTimezoneOffset();
    }

    static getTimeZone(): string {
        let result = '';
        let offSet: number = new Date().getTimezoneOffset();

        if (!this.isDstObserved()) offSet -= 60;
        switch (offSet) {
            case 180:
                result = 'Atlantic';
                break;
            case 240:
                result = 'Eastern';
                break;
            case 300:
                result = 'Central';
                break;
            case 360:
                result = 'Mountain';
                break;
            case 420:
                result = 'Pacific';
                break;
            default:
                result = 'Eastern';
                break;
        }
        return result;
    }
}



// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../utils/common-utils.ts